<template>
    <div>
        <div class="content" v-if="validateResults.length===0">
            <div class="tab-container">
                <p class="title mb-2">檔案驗證</p>
                <p class="mb-2">僅計算檔案雜湊值，本系統不會保存您的檔案</p>
                <div class="w-100 d-flex justify-content-lg-end justify-content-center">
                    <button class="btn-secondary-blue mb-2" @click="handleUploadButtonClick()">
                        選擇檔案
                    </button>
                    <input type="file" ref="input" multiple v-on:change="onFileChange" style="display:none" />
                </div>
                <b-table class="upload_table" :items="items" :fields="fields" :sort-by.sync="sortBy" label-sort-asc="" label-sort-desc="" label-sort-clear="" :sort-desc.sync="sortDesc" sticky-header hover responsive="sm" style="width:100%">
                    <template #cell(delete_button)="data">
                        <b-icon icon="x-circle-fill" variant="secondary" @click="handleDelete(data.index)" aria-hidden="true">
                        </b-icon>
                    </template>
                </b-table>
            </div>
            <div class="footer">
                <button class="btn-secondary-blue mx-3" @click="resetFile()">回選擇驗證證據</button>
                <button class="btn-primary-sm mx-3" @click="handleValidate()">開始驗證</button>
            </div>
        </div>
        <VerifyResult :items="validateResults" v-else />
    </div>
</template>
<script>
import axios from 'axios'
import moment from 'moment'
import VerifyResult from './VerifyResult.vue'

export default {
    name: "UploadFilePage",
    components: {
        VerifyResult
    },
    props: {
        items: Array,
        onFileChange: Function,
        resetFile: Function,
        handleDelete: Function
    },
    methods: {
        handleUploadButtonClick() {
            this.$refs.input.click();
        },
        async handleValidate() {
            const requests = this.items.map(item => {
                return axios.get(`${process.env.VUE_APP_BACKEND_API_URL}/validate`, {
                    params: {
                        hash: item.hash,
                    }
                })
            })
            const responses = await Promise.all(requests)
            let verifyTime = moment.unix(Math.floor(Date.now() / 1000)).format('YYYY/MM/DD HH:mm:ss');
            const results = responses.map((response, index) => ({ result: response.data.isValid.status, txMap: response.data.isValid.txMap, user: response.data.isValid.user, verifyTime: verifyTime, ...this.items[index] }))
            console.log(results)
            let reportData = {
                verifyTime: verifyTime,
                results: results
            }
            sessionStorage.setItem('reportData', JSON.stringify(reportData));
            this.validateResults = results
        }
    },
    data() {
        return {
            validateResults: [],
            sortBy: "index",
            sortDesc: false,
            fields: [{
                    key: "index",
                    sortable: true,
                    label: "項目",
                    thClass: "color-white border-table-row-primary",
                    tdClass: "border-table-row-primary",
                },
                {
                    key: "fileName",
                    sortable: true,
                    label: "檔案名稱",
                    thClass: "color-white border-table-row-primary",
                    tdClass: "border-table-row-primary",
                },
                {
                    key: "hash",
                    sortable: false,
                    label: "雜湊值",
                    thClass: "color-white border-table-row-primary",
                    tdClass: "border-table-row-primary",
                },
                {
                    key: "delete_button",
                    sortable: false,
                    label: "",
                    thClass: "color-white border-table-row-primary",
                    tdClass: "border-table-row-primary",
                    class: "text-center",
                },
            ],
        };
    },
};
</script>